import { Component, OnInit } from '@angular/core';
import { AdminService } from '../../../../core/services/admin.service';
import { SchoolAndTrainingService } from '../../../../core/services/school-and-training.service';
import { environment } from '../../../../../environments/environment';
import { DomSanitizer } from '@angular/platform-browser';
@Component({
  selector: 'app-pre-installation-system-review',
  templateUrl: './pre-installation-system-review.component.html',
  styleUrls: ['./pre-installation-system-review.component.scss']
})
export class PreInstallationSystemReviewComponent implements OnInit {

  description: string = "";
  pdfUrl: any = null;
  constructor(private adminService: AdminService, private sanitizer: DomSanitizer) { }

  ngOnInit() {
    const body = {
      trainingType: "PreInstallation",
      languageCode: localStorage.getItem("language")
    }
    this.adminService.getTrainingPagesDescription(body).subscribe(response => {
      if (response.length > 0) {
        if (response[0].description) {
          this.description = response[0].description;
        }
        else if (response[0].urlPath) {
          const url = environment.imageUrl + response[0].urlPath;
          this.pdfUrl = this.sanitizer.bypassSecurityTrustResourceUrl(url);
        }
      }
    })
  }

}
